import axios, { AxiosResponse } from "axios";
import {IDataRehabilitation} from "./service-list-persons-on-termination-rehabilitation.type";

/**
 * Получение данных для сервиса Список индивидуальных предпринимателей и юридических лиц,
 * в отношении которых вступило в законную силу определение суда о прекращении реабилитационной процедуры.
 */
export const getDataRehabilitation = (data: IDataRehabilitation): Promise<AxiosResponse<any[]>> => {
  return axios.get(`/services/isnaportalsync/open-api/case-data-of-rehabilitation-which-is-terminated`, {
    params: {
      ...data
    }
  });
};

/**
 * Получение списка КОГД
 */
export const getTaxOrg = (): Promise<AxiosResponse<any[]>> => {
  return axios.get(`/services/isnaportal/open-api/tax-org/search`, {
    params: {
      levels: '1,2'
    }
  });
};

/**
 * Получение excel файла
 */
export const getRehabilitationFile = (filter: any): Promise<AxiosResponse<Blob>> => {
  return axios.get(`/services/isnaportalsync/open-api/case-data-of-rehabilitation-which-is-terminated/file`, {
    responseType: "arraybuffer",
    params: {
      ...filter
    }
  });
};
